import "./bestSeller.css"

export function BestSeller({ product, revenue, sales }) {
    return (
        <div className="d-flex align-items-center mt-3 best-seller ">
            <div className="best-image d-flex justify-content-center ">
                <img src={product.image} alt="" />
            </div>

            <div className="d-flex flex-column gap-1 best-info ms-3 ">
                <div className="best-title ">{product.title}</div>
                <div className="best-price ">
                    ${product.salePrice ? product.salePrice : product.regularPrice}
                </div>
            </div>

            <div className="d-flex flex-column gap-1 best-results ms-auto ">
                <div className="best-revenue text-end ">${revenue}</div>
                <div className="best-sales text-end ">{sales} Sales</div>
            </div>
        </div>
    )
}